<template>
  <div v-if="userLoading" class="table-group">
    <div class="table-loader"></div>
  </div>

  <div v-if="userError" class="mc-error">{{ userError }}</div>

  <UserForm v-if="userLoaded" mode="edit" :user="user" />
</template>

<script>
import UserForm from '@/components/form/UserForm.vue';
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    UserForm,
  },
  created() {
    if (this.profile.role !== 'admin')
      this.$router.push('/');
    this.fetchUser(this.$route.params.id);
  },
  computed: {
    ...mapGetters('user', [
      'user',
      'userLoading',
      'userError',
      'userLoaded',
    ]),
    ...mapGetters({
      profile: 'user'
    })
  },
  methods: {
    ...mapActions('user', [
      'fetchUser',
    ]),
  }
}
</script>